<template>
  <div class="single">
    <div class="wrapper" v-for="(response, index) in choices" :key="response.label">
      <vv-radio
        :name="String(index)"
        :label="response.label"
        :value="index"
        :model-value="value"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { VvRadio } from '@/components/common'

export default {
  name: 'Single',
  components: { VvRadio },
  props: {
    expectedResponse: {
      type: Object,
      required: true,
      validator(value) {
        if (!value.hasOwnProperty('choice')) return false

        return typeof value.choice === 'number'
      }
    },
    choices: {
      type: Array,
      required: true,
      validator(value) {
        return Array.isArray(value) && value.length > 0
      }
    },
    value: {
      type: Number,
      required: false,
      default: null
    }
  },
  methods: {
    handleChange(value) {
      const correct = Number(value) === this.expectedResponse.choice

      this.$emit('change', { value: Number(value), correct })
    }
  }
}
</script>

<style lang="scss" scoped>
.single {
  margin: auto;
  text-align: center;

  .wrapper {
    display: inline-block;
    width: 80%;

    &:not(:first-of-type) {
      margin-top: 20px;
    }
  }
}
</style>
